'use strict';

define('features/ctas/dealer.site.cta',[
  'jquery',
  'lib/util/zip',
  './cta.types',
  './dealer.search.modal',
  'lib/util/tda.config',
  'cookies'
], function (
  $,
  zip,
  ctaTypes,
  DealerSearchModal,
  tdaConfig,
  cookies
) {
  var __type = ctaTypes['dealerSite']; // eslint-disable-line dot-notation
  var __isWWW = tdaConfig.tda.code === 'WWW';
  var __isMirai = window.location.search.indexOf('mirai') >= 0;

  /* TODO:
    check mirai
    remove old urlParam that used to opened the modal
    check data-layer clicks

    check VI page - top and bottom

    no longer need click-to-dealer-button in XSLs

    The following skins are OK, since they dont get a data-destination[dealer-site]:
    find-a-dealer_Smaller_Map_Skin.xsl
    dealer-panel_default-skin
    thankyou.xsl
    dealer-detail_default-skin.xsl
  */
  var dealerSiteCta = {
    dealerSelect: function (e, selectedDealer) {
      e.preventDefault();
      window.open(selectedDealer.siteUrl, '_blank');
    }
  };

  Object.setPrototypeOf(dealerSiteCta, DealerSearchModal);

  return function ($scope) {
    var $ctaScope = $scope || $('body');
    var $ctas = $("a[data-destination='" + __type + "']", $ctaScope);
    if (!$ctas.length) return;

    $ctas.on('click', function (e) {
      e.preventDefault();
      // when this CTA is on a mirai page, we disable PMA mode
      if (__isMirai) dealerSiteCta.setMode('mirai');
      if (__isWWW || cookies.getItem('isConfirmedZip') !== 'true') {
        dealerSiteCta.enterZip();
      } else {
        dealerSiteCta.beginSearch(zip.getCookiedDefaultFallback());
      }
    });
  };
});

